import axios from 'axios';
import store from './store';
import {EventBus} from '@/utils/eventBus';
import Swal from 'sweetalert2';
import { isDev, isLocal } from './helpers';

const API_URL = isDev() || isLocal() ?
    'https://zu296syzu5.execute-api.eu-central-1.amazonaws.com/Prod/' :
    'https://h2pu468pfj.execute-api.eu-central-1.amazonaws.com/Prod';

const HTTP = axios.create({
    baseURL: API_URL
});

HTTP.interceptors.request.use(function (config) {
    if(!config.skipProgressbar) {
        EventBus.emit('progressbar:on');
    }
    const token = store.getters['token'];

    if (token != null && (config.url.indexOf(API_URL) > -1 || config.url.indexOf('/') === 0)) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, function (error) {
    console.log(error);
    return Promise.reject(error);
});

HTTP.interceptors.response.use(function (response ) {
    if(!response.config.skipProgressbar) {
        EventBus.emit('progressbar:off');
    }
    if (response.data.message) {
        EventBus.emit('bubble:on', response.data.message);
    }
    if (response.data.message) {
        if (response.data.status == 'error') {
            Swal.fire({
                title: 'Error',
                text: response.data.message,
                confirmButtonText: 'OK'
            });
        }
        EventBus.emit('bubble:on', response.data.message);
    }
    return response;
}, function (response) {
    EventBus.emit('progressbar:off');
    if (response.message) {
        EventBus.emit('bubble:on', response.message);
    }
    if(response.status == 'warning') {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
});

//MOCK
if (API_URL == 'mock') {
    HTTP.interceptors.response.use(function (response ) {
        console.log('getting mock', response);
        return response;
    }, function (error) {
        console.log('getting error', error);
        return Promise.reject(error);
    });
}

export default HTTP;
